import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TestResultService} from '../../shared/services/api-services/test-result.service';
import {TestResultQueryModel} from '../../shared/models/test-result-query.model';
import {DocumentModel} from '../../shared/models/document.model';
import {NotificationService} from '../../shared/services/utilities/notification.service';
import {NationalCodeValidatorService} from '../../shared/services/utilities/national-code-validator.service';


@Component({
  selector: 'app-search-test-result',
  templateUrl: './search-test-result.component.html',
  styleUrls: ['./search-test-result.component.scss']
})

export class SearchTestResultComponent implements OnInit {

  resultReady = false;
  resultMessage: string = null;
  searchForm: FormGroup;
  documents: DocumentModel[];
  recaptcha = new FormControl(false);
  isCaptchaLoaded = false;

  constructor(private formBuilder: FormBuilder,
              private notificationService: NotificationService,
              private testResultService: TestResultService,
              private nationalCodeValidatorService: NationalCodeValidatorService) {

    this.searchForm = this.formBuilder.group({
      nationalCode: ['', [
        Validators.required,
        Validators.minLength(10),
        this.nationalCodeValidatorService.nationalCodeValidator]],
      privateId: ['', [Validators.required]],
      receptionNo: ['', [Validators.required, Validators.min(10000000), Validators.max(99999999)]],
    });
  }

  ngOnInit() {
  }

  recaptchaLoaded() {
    this.isCaptchaLoaded = true;
  }

  recaptchaLoadError() {
    this.isCaptchaLoaded = false;
  }

  search() {
    this.resultReady = true;
    const query: TestResultQueryModel = {
      nationalCode: this.searchForm.controls.nationalCode.value,
      receptionNo: this.searchForm.controls.receptionNo.value,
      privateId: this.searchForm.controls.privateId.value
    };

    this.testResultService.get(query)
      .subscribe((documents: DocumentModel[]) => {
        this.documents = documents;
        this.resultMessage = null;
      }, (error) => {
        this.resultMessage = this.notificationService.showStrcturedError(error.error);
        this.documents = null;
        this.resultReady = false;
      }, () => {
        this.resultReady = false;
      });
  }
}
